import "normalize.css"
import "./tachyons/css/tachyons.css"
import "./src/styles"

import WrapProvider from "./wrapProvider"

export const wrapRootElement = WrapProvider

export const onRouteUpdate = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
}
